import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Model } from 'src/app/shared/models/clux/model-legacy';

@Component({
  selector: 'app-signin-security-federated-modal',
  templateUrl: 'signin-security-federated-modal.component.html',
  styleUrls: ['./signin-security-federated-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SigninSecurityFederatedModalComponent {
  private router = inject(Router);
  public dialog = inject(MatDialog);
  public data = inject<Model.MatDialogModel>(MAT_DIALOG_DATA);
  private modalRef = inject<MatDialogRef<SigninSecurityFederatedModalComponent>>(MatDialogRef);

  private identityProvider: string;

  public async goToDashboard(): Promise<void> {
    this.modalRef.close();
    await this.router.navigate(['/home']);
  }
}
